/**
 * The sentences Home builds around the briefing: the greeting, the lead line
 * under it, and the "Written 12:04 AM · 2 changes" meta on Since Yesterday.
 */
import dayjs from "dayjs";

import { timeOfDay } from "../greeting";
import type { BriefingResponse } from "../types";

export const greetingLine = (firstName: string | null, now: Date): string => {
  const tod = timeOfDay(now).toLowerCase();
  const name = (firstName ?? "").trim();
  return name ? `Good ${tod}, ${name}` : `Good ${tod}`;
};

const sinceLabel = (generatedAt: string | null): string => {
  if (!generatedAt) return "yesterday";
  const d = dayjs(generatedAt).subtract(1, "day").hour(17).minute(0);
  return `${d.format("h A")} yesterday`;
};

const plural = (n: number, word: string) => `${n} ${word}${n === 1 ? "" : "s"}`;

/** "Your assistant read 2 changes since 5 PM yesterday." */
export const briefingLead = (briefing: BriefingResponse | null): string =>
  briefing && briefing.changes_count > 0
    ? `Your assistant read ${plural(
        briefing.changes_count,
        "change"
      )} since ${sinceLabel(briefing.generated_at)}.`
    : "Nothing new since yesterday.";

/** "Written 12:04 AM · 2 changes"; empty before the first briefing. */
export const writtenMeta = (briefing: BriefingResponse | null): string => {
  if (!briefing?.generated_at) return "";
  const at = dayjs(briefing.generated_at);
  if (!at.isValid()) return "";
  return `Written ${at.format("h:mm A")} · ${plural(
    briefing.changes_count,
    "change"
  )}`;
};
